import { Logo } from "./Logo";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-auto w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-4 sm:h-16 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-4 sm:gap-0">
          <Logo />
          <p className="text-sm text-center text-gray-500 dark:text-gray-400">
            <span style={{ fontFamily: "Arial" }}>&copy;</span>&nbsp;{currentYear}&nbsp;GuGuData.AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
